export default __webpack_public_path__ + "static/media/meetfresh.a96fd153.jpeg";